import { generateTypes } from '../utils/HttpReducerHelper';

const fundingSearchActive = generateTypes('FUNDING_SEARCH', 'FUNDING_SEARCH_ACTIVE');
const fundingSearchCompleted = generateTypes('FUNDING_SEARCH', 'FUNDING_SEARCH_COMPLETED');
const fundingSearchShared = generateTypes('FUNDING_SEARCH', 'FUNDING_SEARCH_SHARED');
const fundingSearch = generateTypes('FUNDING_SEARCH', 'FUNDING_SEARCH');
const fundingSearchCompleteApplication = generateTypes('FUNDING_SEARCH', 'COMPLETE_APPLICATION');
const fundingSearchMatches = generateTypes('FUNDING_SEARCH_MATCHES', 'FUNDING_SEARCH_MATCHES');
const cancelFundingSearch = generateTypes('FUNDING_SEARCH', 'CANCEL_FUNDING_SEARCH');
const cancelFundingSearchNewHub = generateTypes('FUNDING_SEARCH', 'CANCEL_FUNDING_SEARCH_NEW_HUB');
const deleteBusinessProfile = generateTypes('FUNDING_SEARCH', 'DELETE_BUSINESS_PROFILE');
const deleteBusinessProfileNewHub = generateTypes(
  'FUNDING_SEARCH',
  'DELETE_BUSINESS_PROFILE_NEW_HUB',
);
const dismissFundingSearchBanner = generateTypes('FUNDING_SEARCH', 'DISMISS_FUNDING_SEARCH_BANNER');
const requestFundingSearchHelp = generateTypes('FUNDING_SEARCH', 'REQUEST_FUNDING_SEARCH_HELP');
const OPEN_CANCEL_FUNDING_SEARCH_MODAL =
  'platfi-ui-app/FUNDING_SEARCH/OPEN_CANCEL_FUNDING_SEARCH_MODAL';
const CLOSE_CANCEL_FUNDING_SEARCH_MODAL =
  'platfi-ui-app/FUNDING_SEARCH/CLOSE_CANCEL_FUNDING_SEARCH_MODAL';
const OPEN_DELETE_DIRECTOR_CONFIRMATION_MODAL =
  'platfi-ui-app/OPEN_DELETE_DIRECTOR_CONFIRMATION_MODAL';
const CLOSE_DELETE_DIRECTOR_CONFIRMATION_MODAL =
  'platfi-ui-app/CLOSE_DELETE_DIRECTOR_CONFIRMATION_MODAL';
const REQUEST_DOWNLOAD_PROFILE_ATTACHMENT =
  'platfi-ui-app/FUNDING_SEARCH/REQUEST_DOWNLOAD_PROFILE_ATTACHEMENT';
const REQUEST_FUNDING_MATCHES_REQUIREMENTS =
  'platfi-ui-app/FUNDING_SEARCH/REQUEST_FUNDING_MATCHES_REQUIREMENTS';
const REQUEST_FUNDING_SEARCH_DOCUMENTS =
  'platfi-ui-app/FUNDING_SEARCH/REQUEST_FUNDING_SEARCH_DOCUMENTS';
const OPEN_DELETE_BUSINESS_PROFILE_MODAL =
  'platfi-ui-app/FUNDING_SEARCH/OPEN_DELETE_BUSINESS_PROFILE_MODAL';
const CLOSE_DELETE_BUSINESS_PROFILE_MODAL =
  'platfi-ui-app/FUNDING_SEARCH/CLOSE_DELETE_BUSINESS_PROFILE_MODAL';
const OPEN_REQUEST_FUNDING_SEARCH_HELP_MODAL =
  'platfi-ui-app/FUNDING_SEARCH/OPEN_REQUEST_FUNDING_SEARCH_HELP_MODAL';
const CLOSE_REQUEST_FUNDING_SEARCH_HELP_MODAL =
  'platfi-ui-app/FUNDING_SEARCH/CLOSE_REQUEST_FUNDING_SEARCH_HELP_MODAL';
const SET_FUNDING_SEARCH_PROFILE_COMPLETION =
  'platfi-ui-app/FUNDING_SEARCH/SET_FUNDING_SEARCH_PROFILE_COMPLETION';
const SET_TRADE_HISTORY_ACCOUNTING_SOLUTION =
  'platfi-ui-app/FUNDING_SEARCH/SET_TRADE_HISTORY_ACCOUNTING_SOLUTION';

export * from './contactDetails/types';
export * from './dueActivitiesCount/types';
export * from './match/types';
export * from './offers/types';
export * from './offersHistory/types';
export * from './privacyToggle/types';
export * from './searchFollowers/types';
export * from './searchManager/types';

export {
  fundingSearchActive,
  fundingSearchCompleted,
  fundingSearchShared,
  fundingSearch,
  fundingSearchCompleteApplication,
  fundingSearchMatches,
  cancelFundingSearch,
  cancelFundingSearchNewHub,
  deleteBusinessProfile,
  deleteBusinessProfileNewHub,
  OPEN_CANCEL_FUNDING_SEARCH_MODAL,
  CLOSE_CANCEL_FUNDING_SEARCH_MODAL,
  OPEN_DELETE_DIRECTOR_CONFIRMATION_MODAL,
  CLOSE_DELETE_DIRECTOR_CONFIRMATION_MODAL,
  REQUEST_DOWNLOAD_PROFILE_ATTACHMENT,
  REQUEST_FUNDING_SEARCH_DOCUMENTS,
  REQUEST_FUNDING_MATCHES_REQUIREMENTS,
  OPEN_DELETE_BUSINESS_PROFILE_MODAL,
  CLOSE_DELETE_BUSINESS_PROFILE_MODAL,
  dismissFundingSearchBanner,
  requestFundingSearchHelp,
  OPEN_REQUEST_FUNDING_SEARCH_HELP_MODAL,
  CLOSE_REQUEST_FUNDING_SEARCH_HELP_MODAL,
  SET_TRADE_HISTORY_ACCOUNTING_SOLUTION,
  SET_FUNDING_SEARCH_PROFILE_COMPLETION,
};
